
import React, { useEffect, useState } from 'react';
import styles from './AddLeaseTemplate.module.css';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Helmet } from 'react-helmet';
import { Button, IconButton, Slide, Snackbar, TextField, Typography } from '@mui/material';
import { ArrowLeft, Home, X } from 'react-feather';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Editor } from '@tinymce/tinymce-react';
import { useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-smart-toaster";
import Loader from '../../components/Loader';
import { FromLoader } from '../../components/LoaderC';
import Footer from '../../components/Footer';

const schema = yup.object().shape({
    title: yup.string().required("This field is Required").max(50, "Layout title can not be more than 4 characters"),
    description: yup.string().required("This field is Required")
});

const LeaseTemplateAddForm = ({ history, match }) => {
    const redirect = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const { property_id, id } = match.params;
    const isAddMode = !id;
    const contentLoading = false;
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");

    const { errors, control, handleSubmit, setValue } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            title: ''
        }
    });

    useEffect(() => {
        async function fetchData() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios.get(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + property_id + "/leases/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                setValue("title", response.data.data?.title);
                setValue("description", response.data.data?.description);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        }

        if (id) {
            fetchData();
        }
    }, [id, getAccessTokenSilently, property_id, setValue]);

    const onSubmit = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + property_id + "/leases", data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarMsg("Lease document added successfully.");
            setSnackbarOpen(true);

            setTimeout(() => {
                localStorage.setItem("propertyTabVal", 3);
                redirect.push('/properties/details/' + property_id);
            }, 2000);

        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + property_id + "/leases/" + id, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarMsg("Lease document updated successfully.");
            setSnackbarOpen(true);

            setTimeout(() => {
                localStorage.setItem("propertyTabVal", 3);
                redirect.push('/properties/details/' + property_id);
            }, 2000);

        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<React.Fragment>
        {loading && <Loader />}
        <Helmet title={((isAddMode) ? 'New Lease Template' : 'Update Lease Template')} />
        {/* <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>{((isAddMode) ? 'New Lease Template' : 'Update Lease Template')}</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Properties</li>
                    <li className={`${styles.breadcrumbItem}`}>Lease Template</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>{(isAddMode) ? 'Add' : 'Edit'}</li>
                </ol>
            </nav>
        </div> */}

        <div className={`${styles.mainCard}`}>
            {contentLoading && <div className="Loader FromLoader"><FromLoader /></div>}
            <div className={`${styles.SMProCusRow}`}>
                <div className={`${styles.BreadcrumbHeadSec}`}>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Properties</li>
                            <li className={`${styles.breadcrumbItem}`} onClick={() => redirect.goBack()}>Lease Template</li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>{(isAddMode) ? 'Add' : 'Edit'}</li>
                        </ol>
                    </nav>
                    <div className={`${styles.PageTitleSec}`}>
                        <div>
                            <button onClick={() => redirect.goBack()} className={`${styles.BackArrow}`}><ArrowLeft /></button>
                            <Typography display="inline" className={`${styles.pageTitle}`}>{((isAddMode) ? 'New Lease Template' : 'Update Lease Template')}</Typography>
                        </div>
                    </div>
                </div>
                {!contentLoading && <div className={`${styles.AddUserMain}`}>
                    <form onSubmit={handleSubmit(isAddMode ? onSubmit : onUpdate)}>
                        <div className={`${styles.AddLeaseSection}`}>
                            <div className={`${styles.AddDocTitleSec}`}>
                                <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                    <Controller
                                        name="title"
                                        control={control}
                                        render={(field) => (
                                            <TextField
                                                {...field}
                                                id="outlined-basic"
                                                variant="outlined"
                                                label="Title*"
                                            />
                                        )}
                                    />
                                    {errors.title && (<p className={`${styles.ErrorM}`}>{errors.title.message}</p>)}
                                </div>
                            </div>
                            <div className={`${styles.FormGroupTextareaFull}`}>
                                <label className={`${styles.FilterLabel}`}>Description<span className={`${styles.errorSpan}`}>*</span></label>
                                <Controller
                                    name="description"
                                    control={control}
                                    render={(field) => (
                                        <Editor
                                            className={`${styles.formControlTextArea}`}
                                            apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                                            value={field?.value}
                                            init={{
                                                height: 500,
                                                menubar: false,
                                                plugins: ["lists", "code", "table"],
                                                toolbar: [
                                                    "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor removeformat | alignleft aligncenter alignright alignjustify | numlist bullist | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | code",
                                                    "tenant1name tenant1 tenant2name tenant2 tenant3name tenant3 property_owner property_manager propertyowner apartment_location security monthlyrent term start_date end_date",
                                                ],
                                                font_size_formats: "10px 12px 14px 16px 18px 20px 24px 36px 48px",
                                                font_family_formats: `Andela Mono='Andela Mono', monospace;
                                                    Arial=arial,helvetica,sans-serif;
                                                    Arial Black='Arial Black', Gadget, sans-serif;
                                                    Book Antiqua='Book Antiqua', Palatino, serif;
                                                    Comic Sans MS='Comic Sans MS', cursive, sans-serif;
                                                    Courier New='Courier New',courier,monospace;
                                                    Georgia=georgia,palatino;
                                                    Helvetica=Helvetica,Arial,sans-serif;
                                                    Impact='Impact', Charcoal, sans-serif;
                                                    Times New Roman='Times New Roman',times;
                                                    Verdana=verdana,geneva;
                                                    Honey Script='Honey Script', cursive;`,
                                                content_style: `
                                                    @font-face {
                                                        font-family: 'Honey Script';
                                                        src: url('/fonts/HoneyScript-Light.ttf') format('truetype');
                                                        font-weight: 300;
                                                        font-style: normal;
                                                    }
                                                    @font-face {
                                                        font-family: 'Honey Script';
                                                        src:  url('/fonts/HoneyScript-SemiBold.ttf') format('truetype');
                                                        font-weight: 600;
                                                        font-style: normal;
                                                    }
                                                    body { font - family:Helvetica,Arial,sans-serif; font-size:16px }
                                                `,
                                                setup: (editor) => {
                                                    editor.ui.registry.addButton("tenant1", {
                                                        text: "Tenant 1 Signature",
                                                        onAction: () =>
                                                            editor.insertContent(
                                                                `<img src="${process.env.REACT_APP_BASE_URL}/static/tenant-1-signature-name.jpg" width="250" />`
                                                            ),
                                                    });
                                                    editor.ui.registry.addButton("tenant2", {
                                                        text: "Tenant 2 Signature",
                                                        onAction: () =>
                                                            editor.insertContent(
                                                                `<img src="${process.env.REACT_APP_BASE_URL}/static/tenant-2-signature-name.jpg" width="250" />`
                                                            ),
                                                    });
                                                    editor.ui.registry.addButton("tenant3", {
                                                        text: "Tenant 3 Signature",
                                                        onAction: () =>
                                                            editor.insertContent(
                                                                `<img src="${process.env.REACT_APP_BASE_URL}/static/tenant-3-signature-name.jpg" width="250" />`
                                                            ),
                                                    });
                                                    editor.ui.registry.addButton("property_owner", {
                                                        text: "Owner",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{PropertyOwner}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("property_manager", {
                                                        text: "Property Manager",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{PropertyManager}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("tenant1name", {
                                                        text: "Tenant 1 Name",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{Tenant1Name}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("tenant2name", {
                                                        text: "Tenant 2 Name",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{Tenant2Name}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("tenant3name", {
                                                        text: "Tenant 3 Name",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{Tenant3Name}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("apartment_location", {
                                                        text: "Apartment Location",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{ApartmentLocation}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("term", {
                                                        text: "Lease Term",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{LeaseTerm}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("security", {
                                                        text: "Security Deposit",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{SecurityDeposit}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("monthlyrent", {
                                                        text: "Monthly Rent",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{MonthlyRent}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("start_date", {
                                                        text: "Start Date",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{StartDate}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("end_date", {
                                                        text: "End Date",
                                                        onAction: () =>
                                                            editor.insertContent(` {{{{EndDate}}}} `),
                                                    });
                                                    editor.ui.registry.addButton("propertyowner", {
                                                        text: "Property Manager Signature",
                                                        onAction: () =>
                                                            editor.insertContent(
                                                                `<img src="${process.env.REACT_APP_BASE_URL}/static/property-owner-signature-name.jpg" width="250" />`
                                                            ),
                                                    });
                                                },
                                            }}
                                            onEditorChange={(e) => field.onChange(e)}
                                        />
                                    )}
                                />
                                {errors.description && (<p className={`${styles.ErrorM}`}>{errors.description.message}</p>)}
                            </div>
                            <div className={`${styles.ButtonAction}`}>
                                <Button className={`${styles.CancelPopupBU}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); localStorage.setItem("propertyTabVal", 3); redirect.push('/properties/details/' + property_id); }}>Cancel</Button>
                                <Button className={`${styles.SubmitPopupBU}`} type="submit">Save</Button>
                            </div>
                        </div>
                    </form>
                </div>}
            </div>
        </div>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

        <Footer />
    </React.Fragment>);
}


export default withAuthenticationRequired(LeaseTemplateAddForm, {
    onRedirecting: () => <Loader />,
});